import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { CitysprintWizardActions } from '../redux';

const CITYSPRINT_WIZARD_PATH_PREFIXES = [
  '/send-citysprint-parcel',
  '/citysprint/',
];

function isCitysprintWizardPath(pathname) {
  return CITYSPRINT_WIZARD_PATH_PREFIXES.some(prefix =>
    pathname.startsWith(prefix)
  );
}

export function useCitysprintWizardExitGuard() {
  const dispatch = useDispatch();

  useEffect(
    () => () => {
      if (!isCitysprintWizardPath(window.location.pathname)) {
        dispatch(CitysprintWizardActions.clear());
      }
    },
    [dispatch]
  );
}
